import { v4 as uuidv4 } from "uuid";
// Risk levels come from PMORisks (name, default goal, order). Colours and icons stay in code, keyed by the level's Id;
// a level added later by script gets the neutral style until it is added here.
export var ClientRiskColor;
(function (ClientRiskColor) {
    ClientRiskColor[ClientRiskColor["Red"] = 1] = "Red";
    ClientRiskColor[ClientRiskColor["Orange"] = 2] = "Orange";
    ClientRiskColor[ClientRiskColor["Green"] = 3] = "Green";
})(ClientRiskColor || (ClientRiskColor = {}));
const clientRiskIcons = {
    [ClientRiskColor.Red]: "bx bx-error",
    [ClientRiskColor.Orange]: "bx bx-error-circle",
    [ClientRiskColor.Green]: "bx bxs-badge-check",
};
const clientRiskColorNames = {
    [ClientRiskColor.Red]: "red",
    [ClientRiskColor.Orange]: "orange",
    [ClientRiskColor.Green]: "green",
};
export function clientRiskColorIcon(id) {
    return clientRiskIcons[id] || "";
}
// "red" / "orange" / "green" for the known levels, "other" for any level without a colour of its own
export function clientRiskColorName(id) {
    return clientRiskColorNames[id] || "other";
}
export function clientRiskLevelName(levels, id) {
    const level = (levels || []).find((x) => x.id === id);
    return level ? level.name : "";
}
export class ClientRiskModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = "";
        this.riskColor = null;
        this.goal = null;
        this.riskDate = null;
        this.riskDateAsString = "";
        this.description = "";
        this.createdOn = null;
        this.createdBy = "";
        this.createdByName = "";
        this.createdByImageURL = "";
    }
}
export default class ClientRisk extends ClientRiskModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
